import(/* webpackMode: "eager" */ "/app/src/app/[lng]/(use-auth)/faqs/page.tsx");
